export default __webpack_public_path__ + "static/media/thumbnil2.1ea521c0.png";